import React from "react";
import { WorkerResponse, WorkerChannelResponse } from "../models/TwilioModels";
import { WorkerCard } from "./WorkerCard";
import { generateTableHeight } from "../utils";
import { WorkerChannelsViewer } from "./WorkerChannelsViewer";
import { Fetcher } from "./Fetcher";
import { Typography } from "@material-ui/core";

interface TwilioWorkerListContainerProps {
	//List of workers to be shown in this list
	workers: WorkerResponse[];
	//id of subscription
	subscriptionId: string;
	//Sid for account to get details for
	accountSid: string;
	//Id of product
	productId: string;
	//Function to load channels for the specified worker
	loadWorkerChannels: (workerSid: string) => () => Promise<any>;
}

const viewWorkerChannels = (
	workerSid: string,
	workerChannels?: WorkerChannelResponse[],
	loadWorkerChannelsData?: (workerSid: string) => () => Promise<any>,
) => {
	return workerChannels ? (
		<WorkerChannelsViewer workerChannels={workerChannels}></WorkerChannelsViewer>
	) : loadWorkerChannelsData ? (
		<Fetcher action={loadWorkerChannelsData(workerSid)}>
			{(response) => {
				return <WorkerChannelsViewer workerChannels={response.data}></WorkerChannelsViewer>;
			}}
		</Fetcher>
	) : (
		<Typography>No worker channels or worker channels load action found.</Typography>
	);
};

const Row = (props: {
	worker: WorkerResponse;
	index: number;
	loadWorkerChannels: (workerSid: string) => () => Promise<any>;
}) => {
	const { friendlyName, sid, available } = props.worker;

	return (
		<WorkerCard
			friendlyName={friendlyName}
			sid={sid}
			available={available}
			workerChannels={undefined}
			workerChannelsViewer={viewWorkerChannels}
			loadWorkerChannelsFunction={props.loadWorkerChannels}
		></WorkerCard>
	);
};

/**
 * Accepts the list of workers to show on the page, and the function to load channels for individual workers.
 * @param data
 */
export const TwilioWorkerListContainer = (data: TwilioWorkerListContainerProps) => {
	return (
		<div style={{ minHeight: generateTableHeight(data.workers.length) - 1 }}>
			<div style={{ marginTop: 10, width: "100%", overflow: "auto" }}>
				{data.workers.map((worker, index) => (
					<div key={index} style={{ width: "100%" }}>
						<Row worker={worker} index={index} loadWorkerChannels={data.loadWorkerChannels} />
					</div>
				))}
			</div>
		</div>
	);
};
